<template lang="pug">
  .wrapper.challenge-lei
    challenge-title LEI Code {{lei}}
    el-collapse.lei-collapse(
      v-model="activeName"
      accordion
      @change="clearState")
      el-collapse-item(
        title="The entity is already registered under another LEI"
        name="already_registered")
        entity-input(
          :leiCode="duplicateLei"
          placeholder="Please provide the duplicate LEI"
          @select="handleLeiCode")
      el-collapse-item(
        title="The entity is not eligible to have an LEI"
        name="not_eligible")
        el-input.lei-input(
          v-model="comment"
          type="textarea"
          placeholder="Please add comment"
          data-test="lei-challenge-eligibility"
          :autosize="{minRows: 4, maxRows: 7}")
</template>
<script>
import { mapGetters, mapMutations, mapActions, } from 'vuex'
import ChallengeTitle from '@/components/challenge-components/ChallengeTitle'
import { CLEAR_CHALLENGE, SAVE_FIELD, } from '@/store/modules/record/modules/challenge/mutations-types'
import { getFieldIdByPath, } from '@/utils/challenge'
import EntityInput from '@/components/lei-components/inputs/EntityInput'
import { EventBus, } from '@/event-bus'

export default {
  components: {
    EntityInput,
    ChallengeTitle,
  },
  props: {
    lvl1DataCanBeSaved: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      jsonPathLei: '$.lei',
      activeName: '',
      comment: '',
      duplicateLei: '',
    }
  },
  computed: {
    ...mapGetters('record', [ 'lei', ]),
  },
  mounted () {
    EventBus.$on('challenge-save-changes', () => {
      this.saveToVuex()
    })
    EventBus.$on('challengeTabSwitchWithDataLost', () => {
      this.clearState()
    })
    EventBus.$on('challenge-clear', () => {
      this.clearState()
    })
  },
  beforeDestroy () {
    EventBus.$off('challenge-save-changes')
    EventBus.$off('challengeTabSwitchWithDataLost')
    EventBus.$off('challenge-clear')
  },
  methods: {
    handleLeiCode (record) {
      this.duplicateLei = record.code
    },

    clearState () {
      this.clearChallenge()
      this.duplicateLei = ''
      this.comment = ''
      EventBus.$emit('clearEntityInputs')
    },

    async saveToVuex () {
      if (!this.lvl1DataCanBeSaved) {
        return
      }
      if (!this.duplicateLei && !this.comment) {
        this.clearState()
        return
      }

      const { xpath, } = await this.getField(getFieldIdByPath(this.jsonPathLei))
      if (this.duplicateLei) {
        this.saveField({
          original_value: this.lei,
          proposed_value: this.duplicateLei,
          comment: '',
          field: xpath,
          jsonPath: this.jsonPathLei,
          highLevel: 'exclusivity',
        })
      } else {
        this.saveField({
          original_value: this.lei,
          proposed_value: null,
          comment: this.comment,
          field: xpath,
          jsonPath: this.jsonPathLei,
          highLevel: 'eligibility',
        })
      }
    },

    ...mapMutations('record/challenge', {
      saveField: SAVE_FIELD,
      clearChallenge: CLEAR_CHALLENGE,
    }),
    ...mapActions('record/challenge', [ 'getField', ]),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
</style>



// WEBPACK FOOTER //
// src/components/challenge-components/ChallengeLeiCode.vue